import module from 'empresa/module.js'
import template from './template.html'

export class EmpresaAvatarComponent {
  empresaId = null
  descargando = false
  seleccionando = false
  src = null
  link = null
  version = null

  constructor ($api, $window, EmpresaAvatar) {
    this.$api = $api
    this.$window = $window
    this.EmpresaAvatarService = EmpresaAvatar
  }


  $onInit () {
    this.descargar()
  }

  $onDestroy () {
    if (this.src)
      this.$window.URL.revokeObjectURL(this.src)
  }

  actualizar (data) {
    this.seleccionando = false

    if (!data.exito)
      return

    this.descargar()
  }

  descargar () {
    this.descargando = true
    this.seleccionando = false

    this.EmpresaAvatarService.get(this.empresaId)
      .then((response) => (this.src = this.$window.URL.createObjectURL(response.data)))
      .finally(() => (this.descargando = false))
  }

  seleccionar () {
    if (this.descargando) return

    this.seleccionando = true
  }
}

module.component('empresaAvatar', {
  controller: EmpresaAvatarComponent,
  template,
  bindings: {
    empresaId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/avatar/component.js